<template>
  <router-view />
  <major-catalog-login-dialog
    v-model="globalLoginVisible"
    :dialog-title="globalLoginTitle"
    @success="onGlobalMajorLoginSuccess"
  />
</template>

<script>
import MajorCatalogLoginDialog from '@/components/major-catalog-login-dialog.vue'
import {
  GLOBAL_MAJOR_LOGIN_OPEN_EVENT,
  hydrateMajorCatalogSessionFromCookies,
  setMajorCatalogLoginOk,
} from '@/common/js/majorCatalogSession'

export default {
  name: 'App',
  components: {
    MajorCatalogLoginDialog,
  },
  data() {
    return {
      globalLoginVisible: false,
      globalLoginTitle: '请重新登录',
    }
  },
  mounted() {
    hydrateMajorCatalogSessionFromCookies()
    window.addEventListener(GLOBAL_MAJOR_LOGIN_OPEN_EVENT, this.onGlobalMajorLoginOpen)
  },
  beforeUnmount() {
    window.removeEventListener(GLOBAL_MAJOR_LOGIN_OPEN_EVENT, this.onGlobalMajorLoginOpen)
  },
  methods: {
    onGlobalMajorLoginOpen() {
      this.globalLoginTitle = '请重新登录'
      this.globalLoginVisible = true
    },
    onGlobalMajorLoginSuccess() {
      setMajorCatalogLoginOk()
    },
  },
}
</script>
<style>
#app {
  width: 100%;
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-repeat: no-repeat;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-size: cover;
}
</style>